import {putResolve, takeLeading, select, throttle} from 'redux-saga/effects';
import {MENU, MENU_FAILURE, MENU_REQUEST, MENU_SUCCESS} from 'new-constants/api.constants';
import {getMenu} from 'new-actions/api.actions.ts';
import {getCurrentRestaurantIdSelector} from "../selectors";

function isMenuNotFetched(menu, currentRestaurantId) {

	if (!menu.cache.find(menu => menu.restaurantId === currentRestaurantId)) {
		return true;
	}

	return false;
}

function isMenuOutdated(customer, menu, currentRestaurantId) {
	if (!(customer && customer.restaurant && customer.restaurant.restaurantId && customer.restaurant.menuVersion)) {
		return false;
	}

	const currentMenu = menu.cache.find(menu => menu.restaurantId === currentRestaurantId);

	if (
		customer.restaurant?.restaurantId === currentRestaurantId &&
		(customer.restaurant?.menuVersion !== currentMenu.version ||
			customer.customerGroupIds !== currentMenu.customerGroup ||
			customer.locale !== currentMenu.locale)
	) {
		return true;
	}

	return false;
}

function* getMenuIfNecessary() {
	const state = yield select();

	const {customer, menu, connectivity, fetchProgress} = state;

	if (fetchProgress[MENU]) return;

	const currentRestaurantId = getCurrentRestaurantIdSelector(state);

	if (!currentRestaurantId) return;
	if (!customer?.currentCustomer?.restaurant) return;

	if (
		(isMenuNotFetched(menu, currentRestaurantId) ||
			isMenuOutdated(customer.currentCustomer, menu, currentRestaurantId)) &&
		connectivity.isOnline !== false
	) {
		yield putResolve(
			getMenu(
				currentRestaurantId,
				customer.currentCustomer.restaurant.menuVersion,
				customer.currentCustomer.customerGroupIds
			)
		);
	}
}

export const menuUpdaterSaga = function* menuUpdaterSaga() {
	yield throttle(2500, [action => ![MENU_REQUEST, MENU_SUCCESS, MENU_FAILURE].includes(action.type)], getMenuIfNecessary);
};
